import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import {
  clearBacklink,
  setActiveSection,
  setBackLink,
} from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Title } from '@mantine/core'

export const CustomFieldsControl = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      setBackLink({
        title: 'custom field list',
        href: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS}`,
      }),
    )

    return () => {
      dispatch(clearBacklink())
    }
  })

  const buildLink = (link: RoutePaths) => {
    return [
      RoutePaths.ADMIN_SETTINGS,
      RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL,
      link,
    ].join('/')
  }

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Data type ',
            path: buildLink(
              RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_DATA_TYPE,
            ),
          },
          {
            label: 'Field details',
            path: buildLink(
              RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_DETAILS,
            ),
          },
          {
            label: 'Record visibility',
            path: buildLink(
              RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_RECORD_VISIBILITY,
            ),
          },
          {
            label: 'Field-level security',
            path: buildLink(
              RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_LEVEL_SECURITY,
            ),
          },
        ]}
      />
      <Title p="md" order={4}>
        New Custom Field
      </Title>
      <Outlet />
    </>
  )
}
